<template>
  <v-dialog v-model="show" width="500" @click:outside="closeDialog">
    <v-card>
      <v-card-title class="third">
        <span class="d-flex justify-center flex-grow-1 font-weight-bold text-h5 white--text">{{ title }}</span>
        <v-icon size="28" color="white" @click="closeDialog">mdi-close</v-icon>
      </v-card-title>
      <v-card-text v-if="!uploading" class="mt-4 d-flex flex-column align-center">
        <div
          class="file-drop-zone d-flex flex-column align-center justify-center"
          :class="{ 'file-drop-zone--active': isDragging }"
          @dragover.prevent="isDragging = true"
          @dragleave.prevent="isDragging = false"
          @drop.prevent="handleDrop"
          @click="triggerFileInput"
        >
          <v-icon size="64" class="mb-2">mdi-upload</v-icon>
          <span class="text-body-1">Glisser-déposer</span>
        </div>
        <input
          ref="fileInput"
          type="file"
          class="d-none"
          :accept="documentTypesAllowed.join(',')"
          @change="handleFileChange"
        />
        <v-btn
          outlined
          class="mt-4 third--text no-caps-btn"
          color="white"
          @click="triggerFileInput"
        >
          Sélectionner un document
        </v-btn>
      </v-card-text>
      <div v-else class="d-flex justify-center align-center" style="min-height: 180px;">
        <Loader />
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import Loader from '@/components/common/Loader.vue';
import { sendNotification } from '@/helpers/utils';
import { ref } from '@vue/composition-api';

export default {
  components: { Loader },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: 'Sélectionner un document'
    },
    uploading: {
      type: Boolean,
      default: true
    },
    documentTypesAllowed: {
      type: Array,
      default: () => ['application/pdf']
    }
  },
  setup(props, { emit }) {
    const fileInput = ref(null);
    const isDragging = ref(false);

    const closeDialog = () => {
      emit('closeModal');
    };

    const triggerFileInput = () => {
      fileInput.value?.click();
    };

    const handleFileChange = (event) => {
      const files = event.target.files;
      if (files?.length === 1 && props.documentTypesAllowed.includes(files[0].type)) {
        emit('fileSelected', files[0]);
      }else{
        sendNotification('error', 'Veuillez sélectionner un seul fichier');
      }
      event.target.value = '';
    };

    const handleDrop = (event) => {
      isDragging.value = false;
      const files = event.dataTransfer?.files;
      if (files?.length === 1 && props.documentTypesAllowed.includes(files[0].type)) {
        emit('fileSelected', files[0]);
      }else{
        sendNotification('error', 'Veuillez sélectionner un seul fichier');
      }
    };

    return {
      fileInput,
      isDragging,
      closeDialog,
      triggerFileInput,
      handleFileChange,
      handleDrop
    };
  }
};
</script>

<style scoped>
.file-drop-zone {
  width: 100%;
  min-height: 180px;
  border: 2px dashed #ccc;
  border-radius: 8px;
  cursor: pointer;
  transition: border-color 0.2s, background-color 0.2s;
}

.file-drop-zone:hover,
.file-drop-zone--active {
  border-color: #c71900;
  background-color: rgba(199, 25, 0, 0.04);
}
</style>
